import { milestones, honors, teamMembers, companyInfo } from '@/mocks/company';
import SEO from '@/components/feature/SEO';

const contactFormUrl = 'https://readdy.ai/api/form/d9pc0kqftmtnfcfh0k7g';

export default function AboutPage() {

  const faqItems = [
    {
      q: '尊龙集团的主要产品有哪些？',
      a: '尊龙集团主要产品涵盖DRAM存储芯片（DDR4/DDR5/LPDDR4X/LPDDR5X）、内存模组（UDIMM/SODIMM/RDIMM）、嵌入式存储（eMMC/UFS）以及面向数据中心、汽车电子等领域的定制化存储解决方案。',
    },
    {
      q: '尊龙集团的DDR5芯片与竞品相比有哪些优势？',
      a: '尊龙集团DDR5 5600MT/s芯片采用1β先进制程，良率突破92%达到国际一线水平。相比同类产品，在功耗降低20%的同时提供超70%的带宽提升，且具备优异的兼容性和长期供货稳定性。',
    },
    {
      q: '如何申请尊龙集团的产品样品或技术资料？',
      a: '您可以通过本页面的联系表单提交需求，或直接发送邮件至info@zunlonggroup.com。我们的销售技术支持团队将在2个工作日内与您联系，了解具体需求并安排后续流程。',
    },
    {
      q: '尊龙集团是否提供定制化存储方案？',
      a: '是的，尊龙集团拥有强大的芯片设计团队和系统方案能力，可为特定行业客户提供从芯片定制、封装设计到系统级验证的全链路定制化存储解决方案。欢迎通过联系我们表单提交您的具体需求。',
    },
    {
      q: '尊龙集团目前有哪些招聘岗位？',
      a: '尊龙集团持续招聘芯片设计工程师、工艺集成工程师、封装设计工程师、测试工程师等技术岗位，以及市场、销售、供应链等职能岗位。请将简历发送至hr@zunlonggroup.com，我们将及时回复。',
    },
  ];

  return (
    <>
      <SEO
        title="关于我们"
        description="尊龙集团是一家一体化存储器制造公司，总部位于安徽合肥。了解尊龙集团的品牌故事、发展历程、企业荣誉、核心团队及联系方式。"
        keywords="尊龙集团,关于尊龙,半导体企业,存储器公司,合肥企业,尊龙联系方式"
        canonicalPath="/about"
      />

      <main className="pt-16">
        {/* Header */}
        <section className="relative h-[280px] md:h-[350px] overflow-hidden">
          <img
            src="https://readdy.ai/api/search-image?query=Modern%20semiconductor%20corporate%20headquarters%20interior%20lobby%20with%20warm%20golden%20amber%20lighting%2C%20clean%20minimalist%20design%2C%20elegant%20reception%20area%2C%20professional%20corporate%20photography%2C%20wide%20angle%20view&width=1920&height=600&seq=about-hero-01&orientation=landscape"
            alt="尊龙集团"
            className="w-full h-full object-cover object-top"
          />
          <div className="absolute inset-0 bg-gradient-to-b from-black/50 via-black/30 to-black/60" />
          <div className="absolute inset-0 flex items-center">
            <div className="w-full px-4 md:px-6 max-w-[1400px] mx-auto text-center">
              <h1 className="text-2xl md:text-4xl font-heading font-bold text-white mb-3">
                关于尊龙
              </h1>
              <p className="text-white/70 text-sm md:text-base max-w-xl mx-auto">
                一体化存储器制造企业，以技术创新驱动中国存储产业发展
              </p>
            </div>
          </div>
        </section>

        {/* Company Intro */}
        <section className="py-14 md:py-20 bg-background-50">
          <div className="max-w-[1400px] mx-auto px-4 md:px-6">
            <div className="flex flex-col lg:flex-row items-center gap-8 md:gap-12">
              <div className="lg:w-1/2">
                <img
                  src="https://readdy.ai/api/search-image?query=Modern%20semiconductor%20company%20team%20collaboration%20in%20bright%20office%20meeting%20room%2C%20warm%20natural%20lighting%2C%20clean%20corporate%20environment%2C%20professional%20atmosphere%2C%20diverse%20engineers%20discussing%20technology&width=700&height=500&seq=about-intro-02&orientation=landscape"
                  alt="尊龙集团团队"
                  className="w-full h-[280px] md:h-[380px] object-cover rounded-lg"
                />
              </div>
              <div className="lg:w-1/2">
                <p className="text-primary-600 text-sm font-medium tracking-wider mb-2">集团简介</p>
                <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-900 mb-4">
                  关于尊龙集团
                </h2>
                <p className="text-sm md:text-base text-foreground-600 leading-relaxed mb-4">
                  {companyInfo.description}
                </p>
                <p className="text-sm md:text-base text-foreground-600 leading-relaxed mb-6">
                  作为中国存储器产业的新生力量，尊龙集团始终坚持"创新驱动、品质至上、客户为先、合作共赢"的核心价值观，致力于打造具有全球竞争力的存储器品牌。集团在上海、深圳、硅谷和新竹设有研发中心，形成了覆盖芯片设计、工艺开发、产品工程和系统方案的全球化研发网络。
                </p>
                <div className="grid grid-cols-2 gap-4">
                  {companyInfo.values.map((v) => (
                    <div key={v.title} className="flex items-start gap-3">
                      <div className="w-8 h-8 flex items-center justify-center rounded-lg bg-primary-50 text-primary-600 flex-shrink-0">
                        <i className={`${v.icon} text-sm`} />
                      </div>
                      <div>
                        <h3 className="text-sm font-semibold text-foreground-900 mb-1">{v.title}</h3>
                        <p className="text-xs text-foreground-500 leading-relaxed">{v.description}</p>
                      </div>
                    </div>
                  ))}
                </div>
              </div>
            </div>
          </div>
        </section>

        {/* Milestones */}
        <section className="py-14 md:py-20 bg-background-100">
          <div className="max-w-[1400px] mx-auto px-4 md:px-6">
            <div className="text-center mb-10 md:mb-14">
              <p className="text-primary-600 text-sm font-medium tracking-wider mb-2">发展历程</p>
              <h2 className="text-2xl md:text-4xl font-heading font-bold text-foreground-900">
                从创立到量产，每一步都坚实有力
              </h2>
            </div>
            <div className="max-w-3xl mx-auto">
              <div className="relative">
                <div className="absolute left-4 md:left-6 top-0 bottom-0 w-px bg-primary-300/50" />
                {milestones.map((m, i) => (
                  <div key={m.year} className="relative pl-10 md:pl-14 pb-8 md:pb-10 last:pb-0">
                    <div className="absolute left-2.5 md:left-4.5 top-1 w-3 h-3 md:w-3.5 md:h-3.5 rounded-full bg-primary-500 ring-4 ring-background-100" />
                    <span className="text-xs md:text-sm text-primary-600 font-medium">{m.year}</span>
                    <h3 className="text-sm md:text-base font-heading font-semibold text-foreground-900 mt-1 mb-1">
                      {m.title}
                    </h3>
                    <p className="text-xs md:text-sm text-foreground-600 leading-relaxed">
                      {m.description}
                    </p>
                  </div>
                ))}
              </div>
            </div>
          </div>
        </section>

        {/* Honors */}
        <section className="py-14 md:py-20 bg-background-50">
          <div className="max-w-[1400px] mx-auto px-4 md:px-6">
            <div className="text-center mb-10 md:mb-14">
              <p className="text-primary-600 text-sm font-medium tracking-wider mb-2">企业荣誉</p>
              <h2 className="text-2xl md:text-4xl font-heading font-bold text-foreground-900">
                权威认可，实力见证
              </h2>
            </div>
            <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 md:gap-5">
              {honors.map((honor) => (
                <div
                  key={honor.id}
                  className="bg-background-50 border border-background-200/70 rounded-lg p-5 md:p-6 hover:border-accent-300 transition-all duration-200"
                >
                  <div className="w-10 h-10 flex items-center justify-center rounded-lg bg-accent-50 text-accent-600 mb-4">
                    <i className="ri-award-line text-lg" />
                  </div>
                  <span className="text-xs text-foreground-400">{honor.date}</span>
                  <h3 className="font-heading text-sm md:text-base font-semibold text-foreground-900 mt-1 mb-2">
                    {honor.title}
                  </h3>
                  <p className="text-xs text-foreground-500 mb-2">{honor.issuer}</p>
                  <p className="text-xs md:text-sm text-foreground-600 leading-relaxed">{honor.description}</p>
                </div>
              ))}
            </div>
          </div>
        </section>

        {/* Team */}
        <section className="py-14 md:py-20 bg-background-100">
          <div className="max-w-[1400px] mx-auto px-4 md:px-6">
            <div className="text-center mb-10 md:mb-14">
              <p className="text-primary-600 text-sm font-medium tracking-wider mb-2">核心团队</p>
              <h2 className="text-2xl md:text-4xl font-heading font-bold text-foreground-900">
                汇聚全球顶尖半导体人才
              </h2>
            </div>
            <div className="grid grid-cols-1 md:grid-cols-3 gap-4 md:gap-6 max-w-4xl mx-auto">
              {teamMembers.map((member) => (
                <div
                  key={member.id}
                  className="bg-background-50 border border-background-200/70 rounded-lg overflow-hidden text-center"
                >
                  <div className="h-48 md:h-56 overflow-hidden">
                    <img
                      src={member.image}
                      alt={member.name}
                      className="w-full h-full object-cover object-top"
                    />
                  </div>
                  <div className="p-4 md:p-5">
                    <h3 className="font-heading text-base md:text-lg font-semibold text-foreground-900">
                      {member.name}
                    </h3>
                    <p className="text-xs md:text-sm text-primary-600 font-medium mb-3">{member.title}</p>
                    <p className="text-xs md:text-sm text-foreground-600 leading-relaxed">{member.description}</p>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </section>

        {/* FAQ */}
        <section className="py-14 md:py-20 bg-background-50">
          <div className="max-w-[900px] mx-auto px-4 md:px-6">
            <div className="text-center mb-10 md:mb-14">
              <p className="text-primary-600 text-sm font-medium tracking-wider mb-2">常见问题</p>
              <h2 className="text-2xl md:text-4xl font-heading font-bold text-foreground-900">
                您可能关心的问题
              </h2>
            </div>
            <div className="flex flex-col gap-3">
              {faqItems.map((item, i) => (
                <details key={i} className="group bg-background-50 border border-background-200/70 rounded-lg">
                  <summary className="flex items-center justify-between px-5 py-4 cursor-pointer text-sm md:text-base font-medium text-foreground-900 list-none">
                    {item.q}
                    <i className="ri-arrow-down-s-line text-foreground-400 group-open:rotate-180 transition-transform" />
                  </summary>
                  <div className="px-5 pb-4 text-sm text-foreground-600 leading-relaxed">
                    {item.a}
                  </div>
                </details>
              ))}
            </div>
          </div>
        </section>

        {/* Contact */}
        <section className="py-14 md:py-20 bg-background-100">
          <div className="max-w-[1400px] mx-auto px-4 md:px-6">
            <div className="flex flex-col lg:flex-row gap-8 md:gap-12">
              <div className="lg:w-2/5">
                <p className="text-primary-600 text-sm font-medium tracking-wider mb-2">联系我们</p>
                <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-900 mb-4">
                  期待与您沟通
                </h2>
                <p className="text-sm md:text-base text-foreground-600 leading-relaxed mb-6">
                  无论您是寻求高性能存储方案的客户、关注尊龙发展的投资者，还是希望加入我们的人才，我们都真诚欢迎您的联系。
                </p>
                <div className="flex flex-col gap-4">
                  <div className="flex items-start gap-3">
                    <div className="w-9 h-9 flex items-center justify-center rounded-lg bg-primary-50 text-primary-600 flex-shrink-0">
                      <i className="ri-map-pin-line" />
                    </div>
                    <div>
                      <h3 className="text-sm font-semibold text-foreground-900 mb-1">集团总部</h3>
                      <p className="text-xs md:text-sm text-foreground-600">{companyInfo.headquarters}</p>
                    </div>
                  </div>
                  <div className="flex items-start gap-3">
                    <div className="w-9 h-9 flex items-center justify-center rounded-lg bg-primary-50 text-primary-600 flex-shrink-0">
                      <i className="ri-phone-line" />
                    </div>
                    <div>
                      <h3 className="text-sm font-semibold text-foreground-900 mb-1">联系电话</h3>
                      <p className="text-xs md:text-sm text-foreground-600">{companyInfo.phone}</p>
                    </div>
                  </div>
                  <div className="flex items-start gap-3">
                    <div className="w-9 h-9 flex items-center justify-center rounded-lg bg-primary-50 text-primary-600 flex-shrink-0">
                      <i className="ri-mail-line" />
                    </div>
                    <div>
                      <h3 className="text-sm font-semibold text-foreground-900 mb-1">电子邮箱</h3>
                      <p className="text-xs md:text-sm text-foreground-600">{companyInfo.email}</p>
                    </div>
                  </div>
                </div>
              </div>

              <div className="lg:w-3/5">
                <div className="bg-background-50 border border-background-200/70 rounded-lg p-5 md:p-6">
                  <h3 className="font-heading text-base md:text-lg font-semibold text-foreground-900 mb-4">
                    发送消息
                  </h3>
                  <form
                    className="flex flex-col gap-4"
                    data-readdy-form
                    onSubmit={async (e) => {
                      e.preventDefault();
                      const form = e.currentTarget;
                      const honeypot = (form.querySelector('[name="company_alt"]') as HTMLInputElement)?.value?.trim();
                      if (honeypot) return;

                      const formData = new FormData(form);
                      try {
                        const resp = await fetch(contactFormUrl, {
                          method: 'POST',
                          headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
                          body: new URLSearchParams(formData as unknown as Record<string, string>).toString(),
                        });
                        const text = await resp.text();
                        let parsed;
                        try { parsed = JSON.parse(text); } catch { parsed = null; }
                        if (resp.ok && parsed?.code === 'OK') {
                          alert('消息已发送成功，我们将尽快与您联系！');
                          form.reset();
                        } else {
                          alert('发送失败，请稍后重试或直接发送邮件至 info@zunlonggroup.com');
                        }
                      } catch {
                        alert('网络错误，请稍后重试');
                      }
                    }}
                  >
                    <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
                      <div className="flex flex-col gap-1">
                        <label htmlFor="contact-name" className="text-xs font-medium text-foreground-700">姓名</label>
                        <input
                          id="contact-name"
                          name="name"
                          type="text"
                          required
                          className="px-3 py-2.5 border border-background-200 rounded-md text-sm bg-background-50 text-foreground-900 focus:outline-none focus:border-primary-400 transition-colors"
                          placeholder="请输入您的姓名"
                        />
                      </div>
                      <div className="flex flex-col gap-1">
                        <label htmlFor="contact-email" className="text-xs font-medium text-foreground-700">邮箱</label>
                        <input
                          id="contact-email"
                          name="email"
                          type="email"
                          required
                          className="px-3 py-2.5 border border-background-200 rounded-md text-sm bg-background-50 text-foreground-900 focus:outline-none focus:border-primary-400 transition-colors"
                          placeholder="请输入您的邮箱"
                        />
                      </div>
                    </div>
                    <div className="flex flex-col gap-1">
                      <label htmlFor="contact-company" className="text-xs font-medium text-foreground-700">公司</label>
                      <input
                        id="contact-company"
                        name="company"
                        type="text"
                        className="px-3 py-2.5 border border-background-200 rounded-md text-sm bg-background-50 text-foreground-900 focus:outline-none focus:border-primary-400 transition-colors"
                        placeholder="请输入您的公司名称（选填）"
                      />
                    </div>
                    <div className="flex flex-col gap-1">
                      <label htmlFor="contact-message" className="text-xs font-medium text-foreground-700">留言内容</label>
                      <textarea
                        id="contact-message"
                        name="message"
                        required
                        maxLength={500}
                        rows={4}
                        className="px-3 py-2.5 border border-background-200 rounded-md text-sm bg-background-50 text-foreground-900 focus:outline-none focus:border-primary-400 transition-colors resize-none"
                        placeholder="请输入您想了解的内容或合作意向（最多500字）"
                      />
                    </div>
                    <input
                      name="company_alt"
                      type="text"
                      tabIndex={-1}
                      autoComplete="off"
                      aria-hidden="true"
                      readOnly
                      className="spam-field"
                    />
                    <button
                      type="submit"
                      className="inline-flex items-center justify-center gap-2 px-6 py-3 bg-primary-500 hover:bg-primary-600 text-background-50 font-medium rounded-full transition-all duration-200 text-sm whitespace-nowrap"
                    >
                      <i className="ri-send-plane-line" />
                      发送消息
                    </button>
                  </form>
                </div>
              </div>
            </div>
          </div>
        </section>
      </main>

      <script type="application/ld+json">
        {JSON.stringify({
          '@context': 'https://schema.org',
          '@type': 'AboutPage',
          name: '关于尊龙集团',
          description: companyInfo.description,
          url: 'https://www.zunlonggroup.com/about',
          mainEntity: {
            '@type': 'Organization',
            name: '尊龙集团',
            foundingDate: '2025',
            address: {
              '@type': 'PostalAddress',
              streetAddress: '高新技术产业开发区创新大道2800号',
              addressLocality: '合肥',
              addressRegion: '安徽',
              addressCountry: 'CN',
            },
            contactPoint: {
              '@type': 'ContactPoint',
              telephone: companyInfo.phone,
              email: companyInfo.email,
              contactType: 'customer service',
            },
          },
        })}
      </script>

      <script type="application/ld+json">
        {JSON.stringify({
          '@context': 'https://schema.org',
          '@type': 'FAQPage',
          mainEntity: faqItems.map((item) => ({
            '@type': 'Question',
            name: item.q,
            acceptedAnswer: {
              '@type': 'Answer',
              text: item.a,
            },
          })),
        })}
      </script>
    </>
  );
}